// src/app/slices/themeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current: "light", // valeur par défaut
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.current = state.current === "light" ? "dark" : "light";
    },
    setTheme: (state, action) => {
      state.current = action.payload;
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
